export default __webpack_public_path__ + "static/media/AirplaneGoing.a23de3c2.svg";